
import { storage } from '../lib/storage';
import { SubscriptionBox, UserSubscription, SubscriptionFrequency } from '../types';

export const subscriptionService = {
  getStoreBoxes: (storeId: string): SubscriptionBox[] => {
    return storage.getSubscriptionBoxes(storeId);
  },

  getAllBoxes: (): SubscriptionBox[] => {
    return storage.getSubscriptionBoxes().filter(b => b.isActive);
  },

  // Added missing getUserSubscriptions method to resolve error in CustomerSubscriptions page
  getUserSubscriptions: (userId: string): UserSubscription[] => {
    return storage.getUserSubscriptions(userId);
  },

  createBox: (data: Omit<SubscriptionBox, 'id'>) => {
    const newBox: SubscriptionBox = {
      ...data,
      id: 'box-' + Date.now()
    };
    storage.saveSubscriptionBox(newBox);
    return newBox;
  },

  subscribeUser: (userId: string, box: SubscriptionBox) => {
    const now = new Date();
    const nextDate = new Date(now);
    if (box.frequency === 'MONTHLY') nextDate.setMonth(now.getMonth() + 1);
    else nextDate.setMonth(now.getMonth() + 3);

    const sub: UserSubscription = {
      id: 'sub-' + Date.now(),
      userId,
      storeId: box.storeId,
      boxId: box.id,
      status: 'ACTIVE',
      startDate: now.toISOString(),
      nextBillingDate: nextDate.toISOString()
    };

    storage.saveUserSubscription(sub);
    return sub;
  },

  cancelSubscription: (subId: string) => {
    const all = localStorage.getItem('lynqar_user_subs');
    if (!all) return;
    const subs: UserSubscription[] = JSON.parse(all);
    const updated = subs.map(s => s.id === subId ? { ...s, status: 'CANCELLED' as const } : s);
    localStorage.setItem('lynqar_user_subs', JSON.stringify(updated));
  },

  getStoreSubscribersCount: (storeId: string) => {
    const all = localStorage.getItem('lynqar_user_subs');
    if (!all) return 0;
    const subs: UserSubscription[] = JSON.parse(all);
    return subs.filter(s => s.storeId === storeId && s.status === 'ACTIVE').length;
  }
};
